module.exports = __webpack_public_path__ + "media/images/emblems/Roveredo_wappen-5440dfbca2282038e324fd19e1a353fc.svg";